// How far apart the controls of a selected element stay on mobile.
//
// The icons keep a fixed size on screen, so an element dragged small enough pulls
// them onto each other. Everything here is in the units of cornerSize: canvas
// pixels, which is what the controls are positioned and drawn in.

// The white button is 25 wide inside 33 of icon art; the rest is room for the
// drop shadow.
export const CONTROL_BUTTON_RATIO = 25 / 33;

// Centre to centre, as a multiple of the icon: just over the button, so two
// neighbours come as close as they can without touching. Only the buttons count.
// The transparent edge of the art may overlap, and so may the invisible hit areas
// around the icons - see controlHitArea.
export const CONTROL_SPACING_RATIO = 0.8;

export function controlSpacing(cornerSize) {
	return cornerSize * CONTROL_SPACING_RATIO;
}

// The smallest scale at which the corner controls stay `spacing` apart on both
// axes. Two opposite corners are the element plus twice the padding apart: fabric
// zooms the element but not the padding.
export function minScaleForSpacing({ width, height, padding = 0, zoom = 1 }, spacing) {
	const needed = (spacing - 2 * padding) / zoom;
	return Math.max(needed / width, needed / height);
}

// Where a resize that wants `scale` ends up. An element that was already under
// the floor when it was grabbed holds the size it had rather than jumping up to
// the floor, so the first touch of the handle never resizes anything.
export function flooredScale(scale, floor, grabbedScale) {
	const limit = grabbedScale ? Math.min(floor, grabbedScale) : floor;
	return Math.max(scale, limit);
}
